import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { ApiService } from './api.service';
import { ApiConstants } from '../models/apiType.model';
import { CommonService } from './common.service';
import { HostConnectionService } from './host-connection.service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private apiUrl = `${environment.API_URL}${ApiConstants.loginEndPoint}`;

  private hostService = inject(HostConnectionService);
  private jWTToken: string = "";
  setJWTToken(token: string) {
    this.jWTToken = token;
  }
  getJWTToken(): string {
    return this.jWTToken;
  }

  logoutApp(){
    this.hostService.close();
  }

  constructor(private http: HttpClient, private router: Router, private apiService: ApiService, private commonService: CommonService) { }

  loginPost(email: string, password: string): Observable<any> {
    return this.http.post<any>(this.apiUrl, { email, password });
  }

  logout() {
    this.commonService.resetControlsForLogout();
    this.clearToken();
    this.clearUser();    
    this.router.navigate(['/login']);
  }

  async login(data: any): Promise<any> {
    try {
      this.commonService.startSpinner();
      const response: any = await this.apiService
        .postData(ApiConstants.loginEndPoint, data)
        .pipe(
          catchError((error: any) => {
            return of(null);
          })
        )
        .toPromise();

      this.commonService.stopSpinner();
      return response;
    }
    catch (error: any) {
      this.commonService.stopSpinner();
      return null;
    }
  }

  private tokenKey = 'token';

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  setToken(token: string) {
    localStorage.setItem(this.tokenKey, token);
  }

  clearToken() {
    localStorage.removeItem(this.tokenKey);
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem(this.tokenKey);
  }

  private userKey = 'user'
  getUser(): string | null {
    return localStorage.getItem(this.userKey);
  }
  setUser(user: string) {
    localStorage.setItem(this.userKey, user);
  }
  clearUser() {
    localStorage.removeItem(this.userKey);
  }

  private rememberedUserKey = 'rememberedUser'
  getRememberedUser(): string | null {
    return localStorage.getItem(this.rememberedUserKey);
  }
  setRememberedUser(rememberedUser: string) {
    localStorage.setItem(this.rememberedUserKey, rememberedUser);
  }
  clearRememberedUser() {
    localStorage.removeItem(this.rememberedUserKey);
  }

  getStaticToken() : string {
    return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhc2FkLmtoYW5AYXdlc29tZXRlY2hpbmMuY29tIiwianRpIjoiMDQyYWIzY2EtNzRkZS00Y2I5LWIzYTUtOGY0YTY5NzhlZjg3IiwiZW1haWwiOiJhc2FkLmtoYW5AYXdlc29tZXRlY2hpbmMuY29tIiwidWlkIjoiYjkwZjdhNjUtNjhkOS00OWU3LWJkZWUtZDZjNDQwMmYxNGJkIiwiY2lkIjoiM2YyNTA0ZTAtNGY4OS0xMWQzLTlhMGMtMDMwNWU4MmMzMzAxIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiU3VwZXIgQWRtaW4iLCJleHAiOjE3NTI4NTYyMjEsImlzcyI6Imh0dHBzOi8vZW5jb21wYXNzYXV0b21hdGlvbi5hd2Vzb21ldGVjaGluYy5jb20iLCJhdWQiOiJodHRwczovL2VuY29tcGFzc2F1dG9tYXRpb24uYXdlc29tZXRlY2hpbmMuY29tIn0.aPgSPIT-e-WUCteOhAKZAqYgn06ax8rpc4TIiEMcArU';
  }

}
